document.addEventListener('DOMContentLoaded', () => {
    const frames = document.querySelectorAll('.tnt-payment-frame');
    const nameLookup = {
        token: 'tnpay-token',
        full_name: 'tnpay-name',
        last_four_digits: 'tnpay-last4',
        month: 'tnpay-month',
        year: 'tnpay-year'
    }

    function appendHiddenInput(form, name, value) {
        const input = document.createElement('input');
        input.type = 'hidden';
        if (nameLookup[name]) {
            name = nameLookup[name];
        }
        input.name = name;
        input.value = value;
        form.appendChild(input);
    }

    function setSubmitBtnStatus(frame) {
        const form = document.getElementById(frame.dataset.formId);
        const submitBtn = document.getElementById(frame.dataset.submitBtnId);;
        const billMeLater = form['tnpay-card-widget-disabled'];
        const isValid = frame.dataset.isValid === 'true';
        if (billMeLater?.checked) {
            submitBtn.disabled = !billMeLater.checked;
        } else {
            submitBtn.disabled = isValid ? false : true;
        }
    }

    function validateForm(form) {
        if (!$(form).valid()) {
            return false;
        }
        return true;
    }

    window.addEventListener('message', function(e) {
        frames.forEach(frame => {
            if (frame.contentWindow === e.source) {
                const form = document.getElementById(frame.dataset.formId);
                if (e.data?.type == 'SPREEDLY_TOKEN') {
                    appendHiddenInput(form, 'tnpay-card-widget', 1);
                    for (const key in e.data.token) {
                        appendHiddenInput(form, key, e.data.token[key]);
                    }
                    form.requestSubmit();

                } else if (e.data?.type == 'FORM_VALIDATION') {
                    frame.dataset.isValid = e.data.isValid;
                    setSubmitBtnStatus(frame, e.data.isValid);

                } else if (e.data?.type == 'SPREEDLY_ERROR') {
                    e.data.errors.forEach(error => {
                        const errorEl = document.createElement('div');
                        errorEl.classList.add('alert', 'alert-danger', 'payment-error');
                        errorEl.innerText = error.message;
                        form.prepend(errorEl);
                        errorEl.scrollIntoView({block:'center'});
                    });

                } else if (e.data?.type == 'FRAME_HEIGHT') {
                    frame.style.height = e.data.height + 'px';
                }
            }
        });
    });

    frames.forEach(frame => {
        if (frame.dataset.previewMode === 'true') {
            frame.src = __tnt.scrubUrl(frame.src);
        }
        const form = document.getElementById(frame.dataset.formId);
        const submitBtn = document.getElementById(frame.dataset.submitBtnId);
        const billMeLater = form['tnpay-card-widget-disabled'];
        submitBtn.disabled = (billMeLater) ? !billMeLater.checked : true;
        billMeLater?.addEventListener('change', function() {
            setSubmitBtnStatus(frame);
            frame.style.display = (billMeLater.checked) ? 'none' : 'block';
        });
        form.addEventListener('submit', function(e) {
            e.preventDefault();
            const tokenInput = form['tnpay-token'];
            form.querySelectorAll('.payment-error').forEach(paymentError => {
                paymentError.remove();
            });
            if (!validateForm(form)) {
                return false;
            }
            if (tokenInput || billMeLater?.checked) {
                this.submit();
            } else {
                frame.contentWindow.postMessage({action: 'tokenize'});
            }
        });
    });
});